import React, { useState } from 'react';

// Современный компонент календаря
function ModernDatePicker({ value, onChange, className = '' }) {
  const [currentDate, setCurrentDate] = useState(() => {
    if (value) {
      const date = new Date(value);
      return { year: date.getFullYear(), month: date.getMonth() };
    }
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() };
  });

  const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : null);

  const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  const weekDays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    return firstDay === 0 ? 6 : firstDay - 1; // Понедельник = 0
  };

  const generateCalendarDays = () => {
    const daysInMonth = getDaysInMonth(currentDate.year, currentDate.month);
    const firstDay = getFirstDayOfMonth(currentDate.year, currentDate.month);
    const days = [];

    // Дни предыдущего месяца
    const prevMonthDays = getDaysInMonth(currentDate.year, currentDate.month - 1);
    for (let i = firstDay - 1; i >= 0; i--) {
      days.push({
        day: prevMonthDays - i,
        month: currentDate.month - 1,
        year: currentDate.year,
        isCurrentMonth: false
      });
    }

    // Дни текущего месяца
    for (let day = 1; day <= daysInMonth; day++) {
      days.push({
        day,
        month: currentDate.month,
        year: currentDate.year,
        isCurrentMonth: true
      });
    }

    // Дни следующего месяца
    const remainingDays = 42 - days.length; // 6 недель * 7 дней
    for (let day = 1; day <= remainingDays; day++) {
      days.push({
        day,
        month: currentDate.month + 1,
        year: currentDate.year,
        isCurrentMonth: false
      });
    }

    return days;
  };

  const handleDateClick = (day, month, year) => {
    const date = new Date(year, month, day);
    setSelectedDate(date);

    const yearStr = date.getFullYear();
    const monthStr = String(date.getMonth() + 1).padStart(2, '0');
    const dayStr = String(date.getDate()).padStart(2, '0');
    onChange(`${yearStr}-${monthStr}-${dayStr}`);
  };

  const isToday = (day, month, year) => {
    const today = new Date();
    return day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
  };

  const isSelected = (day, month, year) => {
    if (!selectedDate) return false;
    return day === selectedDate.getDate() && month === selectedDate.getMonth() && year === selectedDate.getFullYear();
  };

  return (
    <div className={`modern-date-picker ${className}`.trim()}>
      <div className="calendar-header">
        <button
          className="calendar-nav-btn"
          onClick={() => setCurrentDate(prev => ({
            ...prev,
            month: prev.month === 0 ? 11 : prev.month - 1,
            year: prev.month === 0 ? prev.year - 1 : prev.year
          }))}
        >
          ‹
        </button>
        <div className="calendar-title">
          {months[currentDate.month]} {currentDate.year}
        </div>
        <button
          className="calendar-nav-btn"
          onClick={() => setCurrentDate(prev => ({
            ...prev,
            month: prev.month === 11 ? 0 : prev.month + 1,
            year: prev.month === 11 ? prev.year + 1 : prev.year
          }))}
        >
          ›
        </button>
      </div>

      <div className="calendar-weekdays">
        {weekDays.map(day => (
          <div key={day} className="calendar-weekday">{day}</div>
        ))}
      </div>

      <div className="calendar-grid">
        {generateCalendarDays().map(({ day, month, year, isCurrentMonth }, index) => (
          <button
            key={index}
            className={`calendar-day ${!isCurrentMonth ? 'other-month' : ''} ${isToday(day, month, year) ? 'today' : ''} ${isSelected(day, month, year) ? 'selected' : ''}`}
            onClick={() => handleDateClick(day, month, year)}
            disabled={!isCurrentMonth}
          >
            {day}
          </button>
        ))}
      </div>

      <div className="calendar-footer">
        <button
          className="today-btn"
          onClick={() => {
            const today = new Date();
            setSelectedDate(today);
            setCurrentDate({ year: today.getFullYear(), month: today.getMonth() });

            const yearStr = today.getFullYear();
            const monthStr = String(today.getMonth() + 1).padStart(2, '0');
            const dayStr = String(today.getDate()).padStart(2, '0');
            onChange(`${yearStr}-${monthStr}-${dayStr}`);
          }}
        >
          Сегодня
        </button>
      </div>
    </div>
  );
}

export default ModernDatePicker;
